(function() {
    function initAjaxPagination() {
        const container = document.querySelector("[js-main-collection]")
        const sectionId = container.getAttribute('data-section-id');

        const section = {
            sectionId,
            nodeId: "collectionGrid"
        };


        let currentPage = 1;
        var loading = false;

        window.addEventListener("scroll", function() {
            const ajaxCollectionGrid = container.querySelector(`#${section.nodeId}`);
            const loader = container.querySelector("[js-loader]");
            const page = parseInt(ajaxCollectionGrid.getAttribute("data-pagination"));
            currentPage = parseInt(ajaxCollectionGrid.getAttribute("data-current-page"));
            if(page === 1) return;

            if (ajaxCollectionGrid.getBoundingClientRect().bottom <= window.innerHeight && currentPage < page) {
                if (loading) return;
                loading = true;

                loader.classList.remove('hide');
                renderProducts(ajaxCollectionGrid, loader);
            }
        })

        function renderProducts(ajaxCollectionGrid, loader) {
            currentPage += 1;
            ajaxCollectionGrid.setAttribute("data-current-page", currentPage);
            const href = ajaxCollectionGrid.dataset.collectionUrl;
            const url = location.search ? `${href}${location.search}&page=${currentPage}&section_id=${section.sectionId}` : `${href}?page=${currentPage}&section_id=${section.sectionId}`;

            fetch(url)
            .then(function(response) {
            return response.text();
            }).then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                const ajaxCollectionGrid_ = doc.querySelector(`#${section.nodeId}`);
                ajaxCollectionGrid.insertAdjacentHTML("beforeend", ajaxCollectionGrid_?.innerHTML);

                document.dispatchEvent(new CustomEvent('atc-init'));
                document.dispatchEvent(new CustomEvent("product-media-slider:init"));

                loader.classList.add('hide');
                loading = false;
            }); 
        }
    };

    initAjaxPagination();
    document.addEventListener("ajax-pagination:init", initAjaxPagination)
})()